import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiCreditCard, FiExternalLink, FiRefreshCw } from 'react-icons/fi';
import { billingUiEnabled } from './billingClient';
import useBillingWallet from './useBillingWallet';
import './BillingBalance.scss';

export const CHARGE_URL = 'https://kuebs.com/';

function nativeWebsiteOpener() {
  const ios = window.webkit?.messageHandlers?.callWebSite;
  if (typeof ios?.postMessage === 'function') return (url) => ios.postMessage(url);
  const android = window.myJSInterface;
  if (typeof android?.callWebSite === 'function') return (url) => android.callWebSite(url);
  return null;
}

export function ChargeLink({ className = '' }) {
  const [error, setError] = useState('');
  function openCharge(event) {
    setError('');
    const openNative = nativeWebsiteOpener();
    if (!openNative) return;
    event.preventDefault();
    try { openNative(CHARGE_URL); }
    catch { setError('충전 화면을 열지 못했습니다. 다시 시도해 주세요.'); }
  }
  return <span className={`teacher-charge-link-wrap ${className}`}>
    <a className="teacher-charge-link" href={CHARGE_URL} target="_blank" rel="noopener noreferrer" onClick={openCharge} aria-label="충전하기, 외부 브라우저에서 열기">충전하기 <FiExternalLink aria-hidden="true" /></a>
    {error && <span className="teacher-charge-error" role="alert">{error}</span>}
  </span>;
}

export default function BillingBalance() {
  const { data, loading, requiresLogin, error, balance, refresh } = useBillingWallet();
  if (!billingUiEnabled) return null;
  const value = requiresLogin ? '로그인 필요' : data?.enabled === false ? '서비스 준비 중' : loading ? '확인 중…' : error || balance === null ? '확인 필요' : `${balance.toLocaleString('ko-KR')} C`;
  return <aside className="teacher-billing-balance" aria-label="내 AI 잔액" aria-busy={loading}>
    <div className="teacher-billing-balance-value" aria-live="polite"><FiCreditCard aria-hidden="true" /><span>내 AI 잔액</span><strong>{value}</strong></div>
    <div className="teacher-billing-balance-actions">
      {requiresLogin ? <Link className="teacher-billing-login" to="/login">다시 로그인</Link> : <button type="button" onClick={refresh} disabled={loading} aria-label="AI 잔액 새로고침" title={error || '잔액 새로고침'}><FiRefreshCw aria-hidden="true" /></button>}
      <ChargeLink />
    </div>
    {error && !requiresLogin && <p className="teacher-billing-balance-error" role="alert">{error} 새로고침으로 다시 확인해 주세요.</p>}
  </aside>;
}
